import { useEffect, useState } from 'react';
import { images } from '../../Constants/ImageUrls';
import { isDesktopUser } from '../../Utils/ProductUtils';
import { TooltipContainer } from './styled';

function KwikPassSsoTooltip(props) {
  const {
    setShowSsoTooltip,
    fromCategory,
    fromPdp,
    showSsoTooltip,
    openLoginPopUp,
  } = props;
  const handleCloseTooltip = () => {
    setShowSsoTooltip(false);
    sessionStorage.setItem('kwikpass_sso_tooltip', 'false');
  };

  const [isDesktop, setisDesktop] = useState(false);

  useEffect(() => {
    setisDesktop(isDesktopUser());
  }, []);

  return (
    <TooltipContainer
      className="wobble-animation"
      fromCategory={fromCategory}
      fromPdp={fromPdp}
      showSsoTooltip={showSsoTooltip}
    >
      <div className="upward-arrow"></div>
      <div className="tooltip">
        <div>
          <img
            src="https://images.myloapp.in/NestJsUploads/1752473129452-Black_Offer_icon.svg"
            alt=""
          />
        </div>
        <div>
          <div className="tooltip-content">
            <div>
              <div>
                <h5 className="title">Get Flat 10% OFF</h5>
                <p className="description">
                  On your first order. Use Code: FIRST10
                </p>
              </div>
            </div>
            <div>
              <div className="CrossIcon" onClick={() => handleCloseTooltip()}>
                <img src={images.CrossWhite} alt="" width={11} height={11} />
              </div>
            </div>
          </div>
          {isDesktop ? (
            <button className="sso-button" onClick={openLoginPopUp}>
              Login with SSO
            </button>
          ) : (
            <div
              id="kwikpass-sso-container"
              logo="https://pdp.gokwik.co/kwikpass/assets/icons/kwik_pass_logo.svg"
            ></div>
          )}
        </div>
      </div>
    </TooltipContainer>
  );
}

export default KwikPassSsoTooltip;
